<pos-manager-header [title]="'posManager.posOperators' | transloco" [hasBackDetailedButton]="true"
                    [backUrl]="'../realtime-info/..'"></pos-manager-header>
<ion-content>
  <div class="ion-padding custom-flex-col">
    <div class="segment-container">
      <form [formGroup]="form">
        <ion-segment
          mode="md"
          formControlName="selectedMealId">
          <ion-segment-button [value]="MealTime.Breakfast">
            <ion-label>{{ 'meals.breakfast' | transloco }}</ion-label>
          </ion-segment-button>
          <ion-segment-button [value]="MealTime.Lunch">
            <ion-label>{{ 'meals.lunch' | transloco }}</ion-label>
          </ion-segment-button>
          <ion-segment-button [value]="MealTime.Dinner">
            <ion-label>{{ 'meals.dinner' | transloco }}</ion-label>
          </ion-segment-button>
        </ion-segment>
      </form>
    </div>

    <div class="columns-accordion">
      <ng-template #noOperators>
        <div>{{ 'posManager.noOperatorsFound' | transloco }}</div>
      </ng-template>

      <ng-template #noItems>
        <div class="columns-accordion__columns_content">
          <div class="columns-accordion__column-details">{{ 'posManager.noItemsFound' | transloco }}</div>
        </div>
      </ng-template>

      <div class="operator_table">
        <div class="operator_table__main_header">
          <div class="operator_table__sortable_header" (click)="toggleSort('name')">
            {{ 'posManager.posOperator' | transloco }}
            <ion-icon *ngIf="sortColumn === 'name'" [name]="'name' | sortIcon: sortColumn : sortDirection"></ion-icon>
          </div>
          <div class="operator_table__item_handled operator_table__sortable_header" (click)="toggleSort('orders')">
            {{ 'posManager.ordersHandled' | transloco }}
            <ion-icon *ngIf="sortColumn === 'orders'" [name]="'orders' | sortIcon: sortColumn : sortDirection"></ion-icon>
          </div>
        </div>
        <div class="operator_table__header">
          <div class="columns-accordion__column-details">{{ 'pos.total' | transloco }}</div>
          <div class="columns-accordion__column-handled operator_table__item_handled"> {{ salesByPosOperators | sumTotalTickets }}</div>
        </div>
        <div class="operator_table__item" *ngFor="let operator of (salesByPosOperators | operatorSort: sortColumn : sortDirection);">
          <div>{{ operator.key }}</div>
          <div class="operator_table__item_handled">{{ operator.value.total_tickets }}</div>
        </div>
      </div>


    </div>
  </div>
</ion-content>
